import React from 'react';
import { Helmet } from 'react-helmet';

function Seo({ title, description, url, image }) {
  const siteUrl = 'https://oliverandthetimemachine.com';
  const resolvedUrl = url && url.startsWith('http') ? url : `${siteUrl}${url || ''}`;
  const defaultImagePath = '/assets/img/featured_book_oattm_icon.png';
  const resolvedImage = image && image.startsWith('http') ? image : `${siteUrl}${image || defaultImagePath}`;

  return (
    <Helmet>
      {/* Open Graph (Facebook) */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      {resolvedUrl && <meta property="og:url" content={resolvedUrl} />}
      {resolvedImage && <meta property="og:image" content={resolvedImage} />} 
      <meta property="og:site_name" content="Oliver and the Time Machine" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {resolvedImage && <meta name="twitter:image" content={resolvedImage} />}
      <meta name="twitter:site" content="@oattm_series" />
    </Helmet>
  );
}

export default Seo;


